module.exports = __webpack_public_path__ + "static/img/contact_img3.54fc4d1.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/contact/imgs/contact_img3.png
// module id = wKdA
// module chunks = 1